import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { CAMPOS, CONTACTO_DEFAULT, invalidarContacto } from '../data/contacto'

const API = process.env.REACT_APP_API_URL || ''

export default function AdminAjustes() {
  const [form, setForm] = useState(CONTACTO_DEFAULT)
  const [cargando, setCargando] = useState(true)
  const [guardando, setGuardando] = useState(false)
  const [mensaje, setMensaje] = useState('')
  const [error, setError] = useState('')

  const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` })

  useEffect(() => {
    axios.get(`${API}/api/config/`)
      .then(res => setForm({ ...CONTACTO_DEFAULT, ...res.data }))
      .catch(() => setError('No se pudieron cargar los datos.'))
      .finally(() => setCargando(false))
  }, [])

  const guardar = async (e) => {
    e.preventDefault()
    setGuardando(true); setError(''); setMensaje('')
    try {
      const res = await axios.put(`${API}/api/config/`, form, { headers: headers() })
      setForm({ ...CONTACTO_DEFAULT, ...res.data })
      invalidarContacto()
      setMensaje('Datos guardados. Ya se ven en la web.')
      setTimeout(() => setMensaje(''), 3000)
    } catch (err) {
      setError(err.response?.data?.error || 'No se pudieron guardar los datos.')
    } finally {
      setGuardando(false)
    }
  }

  if (cargando) return <div className="loading">Cargando...</div>

  return (
    <div className="page">
      <div className="page-header">
        <p className="page-label">Panel de administración</p>
        <h1 className="page-title">Datos del bar</h1>
        <div className="page-divider"></div>
        <p style={{ fontSize: '0.75rem', color: 'var(--text-muted)', maxWidth: 560, lineHeight: 1.8 }}>
          Lo que escribas aquí aparece en la portada (Contacto, mapa y pie de página), en la página de alérgenos y en el menú del día.
        </p>
        <Link to="/admin" style={{ display: 'inline-block', marginTop: '0.75rem', fontSize: '0.6rem', color: 'var(--text-muted)', letterSpacing: '0.15em', textTransform: 'uppercase', textDecoration: 'none' }}>
          ← Volver a reservas
        </Link>
      </div>

      {mensaje && <div className="success-msg" style={{ marginBottom: '1.5rem', maxWidth: 560 }}>{mensaje}</div>}
      {error && <div className="error-msg" style={{ marginBottom: '1.5rem', maxWidth: 560 }}>{error}</div>}

      <form onSubmit={guardar} style={{ maxWidth: 560 }}>
        {CAMPOS.map(c => (
          <div className="form-group" key={c.clave}>
            <label>{c.label}</label>
            {c.multilinea ? (
              <textarea
                value={form[c.clave] || ''}
                onChange={e => setForm(f => ({ ...f, [c.clave]: e.target.value }))}
                style={{ height: 'auto', minHeight: 80 }}
                rows={3}
              />
            ) : (
              <input
                type="text"
                value={form[c.clave] || ''}
                onChange={e => setForm(f => ({ ...f, [c.clave]: e.target.value }))}
              />
            )}
            <span className="form-hint">{c.ayuda}</span>
          </div>
        ))}
        <button type="submit" className="btn-primary" disabled={guardando}>
          {guardando ? 'Guardando...' : 'Guardar cambios'}
        </button>
      </form>
    </div>
  )
}
